fx.ns("shared.components", class AddPageComponent extends fx.components.Box
    {    
        constructor(data, model)
        {
            super(data);

            this._model = model;

            this.listenUpdates(model, true);
        }

        get model()
        {
            return this._model;
        }
    
        create()
        {
            super.create();
    
            this.dragContainer = new fx.components.Box("drag-container");
            this.addChild(this.dragContainer, { top : 0, height : "100%", left : 10, right : 10});

            this.container = new fx.components.Box();
            this.lineLeft = new fx.components.Box("line");
            this.lineRight = new fx.components.Box("line");

            this.buttonsContainer = new fx.components.Box("buttons");
            this.insertPagesButton = new fx.components.IconButton({className : "add-page", icon : fx.assets.plusBtn});
            this.insertPagesButton.toolTip = fx.text("Ajouter 2 pages");
            this.buttonsContainer.addChild(this.insertPagesButton, {height : fx.browser.isTablet ? 54 : 40, width : fx.browser.isTablet ? 54 : 40, top:"center", left : "center"});

            //this.removePagesButton = new fx.components.IconButton({className : "page-action remove", icon : fx.assets.removeIcon});
            //this.buttonsContainer.addChild(this.removePagesButton, {height:40, width:40, right : 0})

            this.container.addChild(this.buttonsContainer, { width : fx.browser.isTablet ? 54 : 40, height : fx.browser.isTablet ? 54 : 40, left : "center", top:"center" });

            this.container.addChild(this.lineLeft, {height:0, top : fx.browser.isTablet ? 27 : 20, left : 10});
            this.container.addChild(this.lineRight, {height:0, top : fx.browser.isTablet ? 27 : 20, right : 10});

            this.addChild(this.container, {width : "100%", height:"100%", top : 0, left : 0});

            this.viewport({width : fx.browser.isDesktop ? "75%" : "100%", height : 40});
        }
    
        onReady()
        {
            super.onReady();

            
        }

        onDisplayUpdated()
        {
            super.onDisplayUpdated();
            this.lineLeft.width( (this.realWidth - this.buttonsContainer.realWidth) / 2 - ( fx.browser.isTablet ? 27 : 20 ));
            this.lineRight.width( (this.realWidth - this.buttonsContainer.realWidth) / 2 - (fx.browser.isTablet ? 27 : 20 ));
        }

        onChildUpdated(action)
        {
            if (action.model instanceof models.ProductBookPage && (action.type == "create" || action.type == "delete"))
                this.delay(this._updateToolTip, 250);
            
        }

        vertical(width, height)
        {
            this.viewport({width : width, height : height});

            this.container.viewport({width : width, height : height});
            
            this.lineLeft.viewport({    width : "0", 
                                        height : (this.realHeight - this.buttonsContainer.realHeight) / 2 - 10,
                                        left : "center", 
                                        top : "0"});

            this.lineRight.viewport({   width : "0", 
                                        height : (this.realHeight - this.buttonsContainer.realHeight) / 2 - 10,
                                        left : "center", 
                                        bottom : "0"});

        }

        horizontal(width)
        {
            this.viewport({width : fx.browser.isDesktop ? (width ? width : "75%") : "100%", height : 40});
            this.container.viewport({width : fx.browser.isDesktop ? (width ? width : "75%") : "100%", height : 40});
            
            this.lineLeft.viewport({    width : (this.realWidth - this.buttonsContainer.realWidth) / 2 - ( fx.browser.isTablet ? 27 : 20 ), 
                                        height : 0,
                                        top : fx.browser.isTablet ? 27 : 20, 
                                        left : 10});

            this.lineRight.viewport({   width : (this.realWidth - this.buttonsContainer.realWidth) / 2 - ( fx.browser.isTablet ? 27 : 20 ), 
                                        height : 0,
                                        top : fx.browser.isTablet ? 27 : 20, 
                                        right : 10});

        }

        _updateToolTip()
        {
            this.insertPagesButton.toolTip = this.model.creation.canAdd ? fx.text("Ajouter 2 pages") : fx.text("Vous avez atteint le nombre maximum de pages");
        }
    
    });
    
    

